import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";
import { CLOSE_DIALOG, OPEN_DIALOG } from "./actionTypes";

export const openErrorDialogAction = (e) => (dispatch) =>
  dispatch({
    type: OPEN_DIALOG,
    payload: {
      title: getLocalizedString("defaultErrorDialogTitle"),
      msg: getErrorStringFromServerError(e),
    },
  });

export const openDialogAction = ({
  title,
  msg,
  children,
  onConfirm,
  onCancel,
  acceptOnly,
  acceptText,
  cancelText,
  maxWidth,
  fullWidth,
}) => (dispatch) => {
  dispatch({
    type: OPEN_DIALOG,
    payload: {
      title,
      msg,
      children,
      onConfirm,
      onCancel,
      acceptOnly,
      acceptText,
      cancelText,
      maxWidth,
      fullWidth,
    },
  });
}

export const closeDialogAction = (dispatch) => dispatch({ type: CLOSE_DIALOG });